import React from "react";

import { useAppDispatch, useAppSelector } from "store";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";

import { handleUpdateFields } from "store/cms/customized/slice";
import { useTranslation } from "react-i18next";

interface Props {
  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  readOnly?: boolean;
}

const CmsCustomizedMainTab: React.FC<Props> = ({
  fieldErrors,
  clearFieldError,
  readOnly
}) => {
   const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const payload = useAppSelector((store) => store["cms-customized"].payload);

  const handleChange = (key: string, value: string | boolean | string[]) => {
    dispatch(
      // @ts-ignore
      handleUpdateFields({
        [key]: value,
      }),
    );
  };

  return (
    <div className="customized-form-wrapper customized-group">
      <div className="customized-form-item">
        <InnerInput
          value={payload?.title ?? ""}
          placeholder={t("title")}
          label={t("title")}
          type="text"
          id="customized-title"
          onChange={(e) => {
            handleChange("title", e);
            clearFieldError("title");
          }}
          hasError={Boolean(fieldErrors?.["title"])}
          disabled={readOnly}
        />
      </div>

      <div className="customized-item">
        <InnerInput
          value={payload?.slug ?? ""}
          placeholder={t("slug")}
          label={t("slug")}
          type="text"
          id="customized-slug"
          onChange={(e) => {
            handleChange("slug", e);
            clearFieldError("slug");
          }}
          hasError={Boolean(fieldErrors?.["slug"])}
          disabled={readOnly}
        />
      </div>

      <div className="customized-form-item">
        <SwitchBtn
          activeTxt={t("active")}
          isActive={!!payload?.isActive}
          handleClick={() => {
            handleChange(
              "isActive",
              payload?.isActive ? !payload?.isActive : true,
            );

            clearFieldError("isActive");
          }}
          hasError={Boolean(fieldErrors?.["isActive"])}
          disabled={readOnly}
        />
      </div>
    </div>
  );
};

export default CmsCustomizedMainTab;
